export const roundToNearest = (x: number, nearest = 5) => Math.round(x/nearest)*nearest;

export default {
  roundToNearest,
}